module.exports = __webpack_public_path__ + "static/media/descuento-cilindro-mobile.08937e5e.jpg";